export var ProtectionCapabilityResult;
(function (ProtectionCapabilityResult) {
    // https://docs.microsoft.com/en-us/uwp/api/windows.media.protection.protectioncapabilityresult?view=winrt-22000
    ProtectionCapabilityResult[ProtectionCapabilityResult["NotSupported"] = 0] = "NotSupported";
    ProtectionCapabilityResult[ProtectionCapabilityResult["Maybe"] = 1] = "Maybe";
    ProtectionCapabilityResult[ProtectionCapabilityResult["Probably"] = 2] = "Probably";
})(ProtectionCapabilityResult || (ProtectionCapabilityResult = {}));
export var UwpEvent;
(function (UwpEvent) {
    UwpEvent["Resuming"] = "resuming";
    UwpEvent["Suspending"] = "suspending";
})(UwpEvent || (UwpEvent = {}));
export var XboxModelName;
(function (XboxModelName) {
    XboxModelName["One"] = "Xbox One";
    XboxModelName["OneS"] = "Xbox One S";
    XboxModelName["OneX"] = "Xbox One X";
    XboxModelName["SeriesS"] = "Xbox Series S";
    XboxModelName["SeriesX"] = "Xbox Series X";
})(XboxModelName || (XboxModelName = {}));
//# sourceMappingURL=uwp-types.js.map